import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import customers from './submodules/customers';

const CUSTOMERS_PAGE_SIZE = 500;

/**
 * Fetch all customer IDs matching the given API filters (paginated).
 * Avoids silently truncating assign/replace payloads at an arbitrary limit.
 */
async function fetchAllCustomerIds(filters = {}) {
    const ids = [];
    let offset = 0;
    let total = null;

    while (total === null || offset < total) {
        const response = await axios.get('/api/customers/', {
            params: {
                ...filters,
                limit: CUSTOMERS_PAGE_SIZE,
                offset,
            },
        });
        const results = response.data.results || [];
        total = response.data.count ?? ids.length + results.length;
        ids.push(...results.map((customer) => customer.id));
        if (!results.length) {
            break;
        }
        offset += results.length;
    }

    return ids;
}

const state = {
    catalog: null,
    assigning_catalog: false,
    assigning_catalog_errors: {},

    customers_to_assign: [],

    delivery_address_same_as_billing: true,
    ready: false,
};

const mutations = {
    updateCatalog(state, catalog) {
        state.catalog = catalog;
    },
    updateAssigningCatalog(state, saving) {
        state.assigning_catalog = saving;
    },
    updateAssigningCatalogErrors(state, errors) {
        state.assigning_catalog_errors = errors;
    },

    updateCustomersToAssign(state, customers_to_assign) {
        state.customers_to_assign = customers_to_assign;
    },
    updateReady(state, ready) {
        state.ready = ready;
    }

};

const actions = {

    async assignCustomers({ commit, dispatch, state }) {
        commit('updateAssigningCatalog', true);

        try {
            const response = await axios.post(`/api/catalogs/${state.catalog.id}/assign/`, { customers: state.customers_to_assign });
            commit('updateAssigningCatalog', false);
            dispatch('session/fetchStats', null, { root: true });
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateAssigningCatalogErrors', error.details);
            commit('updateAssigningCatalog', false);
            throw error;
        }
    },

    async assignAllCustomers({ commit }) {
        const ids = await fetchAllCustomerIds({ ordering: 'name' });
        commit('updateCustomersToAssign', ids);
    },

    async assignNoCustomer({ commit }) {
        commit('updateCustomersToAssign', []);
    },

    async init({ commit, dispatch, state }, params) {
        await commit('updateAssigningCatalogErrors', {});
        await commit('updateCatalog', params.catalog);
        await dispatch('customers/init', {
            filters: { limit: 100, ordering: 'name' },
        });
        await dispatch('customers/fetchCustomers');
        await commit('updateCustomersToAssign', []);

        if (params.assign_all) {
            await dispatch('assignAllCustomers');
            await commit('updateReady', true);
        } else {
            const assignedIds = await fetchAllCustomerIds({
                catalog: state.catalog.id,
                ordering: 'name',
            });
            await commit('updateCustomersToAssign', assignedIds);
            await commit('updateReady', true);
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        customers: customers(),
    }
};
